<div class="modal-wrapper">
  <div class="modal-header modal-header--custom">
    <div class="modal-header__title">
      <div class="modal-icon"><mat-icon>cell_tower</mat-icon></div>
      <h4>{{ formMode }} Channel</h4>
    </div>
    <button mat-icon-button class="modal-close-btn" (click)="activeModal.close('close')" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body modal-form-body">
    <form [formGroup]="entryForm" novalidate>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Channel Name</mat-label>
        <input matInput formControlName="channel_name"
               placeholder="Enter channel name"
               [readonly]="editChannel" />
        @if (entryForm.controls['channel_name'].hasError('required')) {
          <mat-error>Channel Name is required</mat-error>
        }
        @if (entryForm.controls['channel_name'].hasError('cannotContainSpace')) {
          <mat-error>Channel Name cannot contain spaces</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Description</mat-label>
        <input matInput formControlName="Description" placeholder="Enter description" />
      </mat-form-field>
    </form>
  </div>

  <div class="modal-footer modal-footer--custom">
    @if (!editChannel) {
      <button mat-flat-button color="primary" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="onCreate_Update()">
        <mat-icon>add</mat-icon> Create
      </button>
    }
    @if (editChannel) {
      <button mat-stroked-button color="warn" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="openConfirmModal('Are you sure you want to Delete?')">
        <mat-icon>delete</mat-icon> Delete
      </button>
    }
  </div>
</div>
